// A MongoDb ID is 24 characters long in hex representation

export default function isValidMongoId(id: string) {
  return /^[a-f\d]{24}$/i.test(id);
}
